import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { createAdventureCardApi as createCardApi, storeAdventureCardApi as storeCardApi } from './adventureCardSlice';
import { schema } from './adventure.yup';
import { FORM_GROUPS } from './constants.adventure';
import FormTabManager from '~/pages/CardSaga/components/FormTabManager.jsx';
import { FormTabProvider } from '~/pages/CardSaga/components/providers/FormTabProvider';

function AdventureCreate() {
    const {
        emptyModel: initialValues,
        frontSides,
        backSides,
        allPictures,
    } = useSelector((state) => state.cardSaga.adventureCard);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formGroups = [...FORM_GROUPS]; //as I use formGroups.shift() (which mutate the original `formGroups`) at `FormTabProvider.jsx` => `formGroups` must be cloned here else so that it is not be shift() again on next visit.
    const cardInformation = formGroups.shift();

    const formSubmit = async (values, formikBag) => {
        dispatch(storeCardApi({ navigate, values, formikBag }));
    };

    useEffect(() => {
        dispatch(createCardApi(navigate));
    }, []);

    return (
        <FormTabProvider
            initialValues={initialValues}
            schema={() => schema()}
            formGroups={formGroups}
            cardInformation={cardInformation}
            frontSides={frontSides}
            backSides={backSides}
            allPictures={allPictures}
        >
            <FormTabManager formSubmit={formSubmit} />
        </FormTabProvider>
    );
}

export default AdventureCreate;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset buttton, don't use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its inital values (I debugged and figured it out).
